module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1524-72fb8ed438805c802388b86ca8fa2727.png";